/**
 * Minimal sync log — Concord V2 hooks use this for debug logging.
 * No-op in production, console.debug in development.
 */

export function logSync(tag: string, message: string): void {
  if (import.meta.env.DEV) {
    console.debug(`[sync:${tag}] ${message}`);
  }
}